<template>
  <div class="box3">
    <pageTitle
      title="AI岗位暴增12倍<br/>全行业高薪抢人"
      text="不愁找不到工作，企业抢着要你"
      titleColor="#24375c"
      titColor="#86909C"
    />

    <div class="job-cards">
      <img
        src="../../../assets/coursePage/llm/box3/job-cards.png"
        alt=""
      />
    </div>

    <div class="stats-box">
      <div class="stats-col">
        <h3 class="stats-col__title">智联招聘数据</h3>
        <p class="stats-col__desc">
          AI相关岗位年增长率超60%，是全行业增速最快的赛道之一
        </p>
      </div>
      <img
        class="stats-box__arrow"
        src="../../../assets/coursePage/llm/box3/arrow-growth.png"
        alt=""
      />
      <div class="stats-col">
        <h3 class="stats-col__title">猎聘2026年数据</h3>
        <p class="stats-col__desc">
          AI工程师平均薪资达25.8K/月，比传统开发岗高出40%+
        </p>
      </div>
    </div>

    <ConsultBtn text='抢占AI"薪"机遇' />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import ConsultBtn from "./ConsultBtn.vue";

export default {
  components: {
    pageTitle,
    ConsultBtn,
  },
};
</script>

<style lang="less" scoped>
.box3 {
  position: relative;
  padding: 80px 32px;
  width: 100%;
  box-sizing: border-box;
 
  overflow: hidden;


  /deep/ .course-title-box {
    position: relative;
    z-index: 1;
  }

  /deep/ .course-title {
    font-size: 48px;
    line-height: 68px;
    font-weight: 500;
  }

  /deep/ .course-text {
    font-size: 26px;
    line-height: 44px;
    margin-top: 14px;
  }

  .job-cards {
    position: relative;
    z-index: 1;
    margin-top: 48px;

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .stats-box {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    margin-top: 48px;
    padding: 0 8px;

    &__arrow {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-73%, -45%);
      width: 160px;
      
    }
  }

  .stats-col {
    width: 288px;
    text-align: center;

    &__title {
      font-family: PingFangSC, PingFang SC;
      font-size: 32px;
      font-weight: 500;
      color: #072557;
      line-height: 48px;
    }

    &__desc {
      margin-top: 12px;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 400;
      color: #667691;
      line-height: 40px;
    }
  }

}
</style>
